import * as React from 'react';
import * as styles from './styles.css';

/**
 * @todo move from deprecated typography to new one
 * @see {@link https://jira.cian.tech/browse/CD-163108}
 */
import { Header0, ArticleHeading2, UIText1 } from '@cian/ui-kit/typography';
import { ConditionalWrapper } from '@cian/conditional-component';
import { useIsDesktop } from '@cian/valuation-utils-component';

import bgImg from '../../static/realtor_completed.png';

export interface IQuizCompletedProps {
  backToPage: React.ReactElement;
  title: string;
  subtitle: string;
  footer?: React.ReactElement;
}

export const QuizCompleted: React.FC<React.PropsWithChildren<IQuizCompletedProps>> = props => {
  const { backToPage, title, subtitle, footer } = props;
  const isDesktop = useIsDesktop();

  return (
    <div className={styles['wrapper']} data-testid="success">
      <div className={styles['header']}>{backToPage}</div>
      <div className={styles['container']}>
        <div className={styles['title']}>
          <ConditionalWrapper if={isDesktop} ThenComponent={Header0} ElseComponent={ArticleHeading2}>
            {title}
          </ConditionalWrapper>
        </div>
        <div className={styles['text']}>
          <UIText1 color="current_color">{subtitle}</UIText1>
        </div>
        {footer && (
          <div className={styles['footer']} data-testid="footer">
            {footer}
          </div>
        )}
        <img src={bgImg} className={styles['image']} />
      </div>
    </div>
  );
};

QuizCompleted.displayName = 'QuizCompleted';
